import { keyframes } from "@emotion/react";
import type { SxProps } from "@mui/system";
import type { ThemeV2 } from "../../../util/types";

const pulse = keyframes({
  "0%, 60%, 100%": {
    opacity: 0.35,
    transform: "translateY(0)",
  },
  "30%": {
    opacity: 1,
    transform: "translateY(-2px)",
  },
});

export const loaderContainer = (
  theme: ThemeV2,
  color = theme.tokens.color.text.secondary,
  messageFirst = false,
): SxProps => ({
  alignItems: "center",
  color,
  display: "inline-flex",
  flexDirection: messageFirst ? "row-reverse" : "row",
  gap: `${theme.tokens.spacing["2"]}px`,
  minHeight: "20px",
  marginLeft: `${theme.tokens.spacing["2"]}px`,
});

export const dotStyle = (theme: ThemeV2, index: number): SxProps => ({
  animation: `${pulse} 1.2s ease-in-out ${index * 0.16}s infinite`,
  backgroundColor: "currentColor",
  borderRadius: "50%",
  height: `${theme.tokens.spacing["1"] * 1.5}px`,
  width: `${theme.tokens.spacing["1"] * 1.5}px`,
});

export const messageStyle = (theme: ThemeV2): SxProps => ({
  color: "inherit",
  fontSize: theme.tokens.typography.size.xs,
  fontWeight: theme.tokens.typography.weight.regular,
  lineHeight: theme.tokens.typography.lineHeight.normal,
  whiteSpace: "nowrap",
});
